import { Chip, Flex } from '@inflearn/ds-react-next';
import { useRouter } from 'next/router';
import type { CSSProperties, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { MyCoursesLayout } from '../../../../components/layout/MyPageLayout/MyCoursesLayout';
import { MY_URL } from '../../../../constants/urls';
import { getPathnameFromSiteURL } from '../../../../utils/url';

export function VoucherAndCertificateLayout({
  children,
  pathname,
  title,
  description,
}: {
  children: ReactNode;
  pathname: string;
  title: string;
  description: string;
}) {
  return (
    <MyCoursesLayout pathname={pathname} title={title} description={description}>
      <VoucherAndCertificateLayoutTabs styles={{ margin: '24px 0' }} />
      {children}
    </MyCoursesLayout>
  );
}

function VoucherAndCertificateLayoutTabs({ styles }: { styles: CSSProperties }) {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <Flex
      gap={10}
      styles={{
        root: styles,
      }}
    >
      <Chip
        variant="outline"
        color="gray"
        size="xs"
        checked={router.pathname === getPathnameFromSiteURL(MY_URL.VOUCHERS())}
        radius="xl"
        onClick={() => {
          router.push(MY_URL.VOUCHERS(), undefined, { shallow: true });
        }}
      >
        {t('수강확인증.plural')}
      </Chip>
      <Chip
        variant="outline"
        color="gray"
        size="xs"
        checked={router.pathname === getPathnameFromSiteURL(MY_URL.CERTIFICATES())}
        radius="xl"
        onClick={() => {
          router.push(MY_URL.CERTIFICATES(), undefined, { shallow: true });
        }}
      >
        {t('수료증', { context: 'plural' })}
      </Chip>
    </Flex>
  );
}
